import { Controller } from "@hotwired/stimulus";

import displayToastMessage from "../utils/display_toast_message";

export default class extends Controller {
  static values = { translations: Object };
  static targets = ["link", "spinner"];

  connect() {
    this.linkTarget.addEventListener("click", this.startDownload.bind(this));
  }

  async startDownload(event) {
    event.preventDefault();
    this.showSpinner();

    try {
      const response = await fetch(this.linkTarget.href);
      if (!response.ok) {
        throw new Error("Network response was not ok.");
      }

      const data = await response.json();
      if (!data.url) {
        throw new Error("No requested URL found.");
      }

      window.location.href = data.url;
    } catch (error) {
      console.error(
        "There has been a problem with your fetch operation:",
        error,
      );
      displayToastMessage({
        text: this.translationsValue.errorMessage,
        icon: "error",
      });
    } finally {
      this.hideSpinner();
    }
  }

  showSpinner() {
    this.spinnerTarget.classList.remove("u-hidden");
    this.linkTarget.classList.add("u-hidden");
    displayToastMessage({
      text: this.translationsValue.waitMessage,
      icon: "info",
    });
  }

  hideSpinner() {
    this.spinnerTarget.classList.add("u-hidden");
    this.linkTarget.classList.remove("u-hidden");
  }
}
